import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 40 40",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsxs("g", {
    fill: "currentColor",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M20 39C9.505 39 1 30.495 1 20S9.505 1 20 1s19 8.505 19 19-8.505 19-19 19zm0-36.19C10.5 2.81 2.81 10.5 2.81 20S10.5 37.19 20 37.19 37.19 29.5 37.19 20 29.5 2.81 20 2.81z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20 20.181c-2.805 0-5.157-2.352-5.157-5.157S17.195 9.867 20 9.867s5.157 2.352 5.157 5.157S22.805 20.18 20 20.18zm0-8.686c-1.99 0-3.529 1.629-3.529 3.529S18.01 18.552 20 18.552s3.529-1.628 3.529-3.528S21.99 11.495 20 11.495zM27.51 29.862a.81.81 0 01-.815-.814c0-3.71-2.986-6.696-6.695-6.696s-6.695 2.986-6.695 6.696c0 .452-.362.814-.814.814s-.815-.362-.815-.814c0-4.615 3.71-8.324 8.324-8.324s8.324 3.71 8.324 8.324a.81.81 0 01-.815.814z"
    })]
  })
});
export default SvgProfile;